export const navItems = [
  {
    icon: '1',
    label: 'Emprendimiento'
  },
  {
    icon: '2',
    label: 'Ubicación'
  },
  {
    icon: '3',
    label: 'Unidades'
  },
  {
    icon: '4',
    label: 'Fotos y Multimedia'
  },
  {
    icon: '5',
    label: 'Extras'
  }
];

export const getPageHeader = (data, create) =>
  create
    ? {
        title: 'Creá un emprendimiento',
        description:
          'Ingresá los datos del emprendimiento que deseas cargar, intentá completar todos los campos para que los usuarios puedan encontrarlo más fácilmente.'
      }
    : {
        title: 'Modificá el emprendimiento',
        description: data?.title
      };
